import { Accordion as MUIAccordion, type AccordionProps } from '@mui/material';

export { type AccordionProps } from '@mui/material';

export function Accordion(props: AccordionProps) {
  return <MUIAccordion {...props} />;
}
